const Empty = require('constants/empty');

const p13nSelector = store => store.p13n || Empty.Object;

module.exports = { p13nSelector };
